"use strict";

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (object) {
  return Object.getOwnPropertySymbols(object).filter(function (keySymbol) {
    return Object.prototype.propertyIsEnumerable.call(object, keySymbol);
  });
};